<template>
  <b-container fluid class="bg-light-gray py-5 h-75 vertical-center">
    <b-jumbotron class="shadow p-5 mb-5 bg-white rounded mx-auto w-50 center text-center">
      <h2 class="my-2">Test Reminder</h2>
      <br>
      <p>
        You will not be allowed to open other programs/browser tabs once you've begun the test. Refreshing the browser window is also prohibited.<br><br>
        Failure to abide by these rules will result in a warning, with succession resulting in the locking of your account.<br><br>
      </p>
        
      <b-form>
        <b-button class="mx-auto w-50" @click="beginTest" variant="primary">Begin Test</b-button>
      </b-form>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {
  name: "ExamineeNoCheatReminder",
  methods: {
    beginTest() {
      this.$store.commit(`exam/testStarted`, false)
      this.$store
        .dispatch("examinee/update", {
          id: this.$store.getters["user/roleId"],
          data: { status: "reminderaccepted" },
        })
        .then(() => {
          return this.$router.push(`/examinee/test`);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="css" scoped>
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 350px;
}
</style>